export default "__VITE_ASSET__1b7898b6__"